function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background: none;\n  border-radius: 999px;\n  width: 2em;\n  height: 2em;\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-around;\n  padding: 0;\n  transition: all 150ms;\n\n  &:hover {\n    background-color: #eee;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "styled-components";
var IconButton = styled.button(_templateObject());
IconButton.displayName = "IconButton";
export default IconButton;
